import EditServiceAttributeDrawer from './EditServiceAttributeDrawer';

export default EditServiceAttributeDrawer;
